import { Switch } from '@base-ui/react/switch';
import styles from "./YuJaSwitch.module.css";
import { useTranslation } from "react-i18next";

export default function YuJaSwitch({
                                       checked,
                                       onChange,
                                       label=true,
                                       disabled=false,
                                       disabledReason,
                                       enabledText="",
                                       disabledText="",
                                       containerStyle={},
                                       ...props
}) {
    const { t } = useTranslation();
    return (
        <label className={styles.Label}>


            {!!label && !!checked && (!!enabledText ? enabledText : t("questionBuilder.enabledText"))}
            {!!label && !checked && (!!disabledText ? disabledText : t("questionBuilder.disabledText"))}

            <Switch.Root
                disabled={disabled}
                checked={checked}
                className={styles.Switch}
                onCheckedChange={(checked, eDetails) => onChange(checked, eDetails.event)}
                {...props}
            >
                <Switch.Thumb className={styles.Thumb}/>
            </Switch.Root>
        </label>
    );
}